import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVerified = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#VerifiedGradient)",
			d: "M8 .837a3.168 3.168 0 0 1 2.47 1.187 3.166 3.166 0 0 1 2.601.906 3.168 3.168 0 0 1 .905 2.6A3.167 3.167 0 0 1 15.164 8a3.172 3.172 0 0 1-1.188 2.47 3.167 3.167 0 0 1-.903 2.597 3.168 3.168 0 0 1-2.596.909 3.167 3.167 0 0 1-4.95.001 3.166 3.166 0 0 1-3.397-2.258 3.169 3.169 0 0 1-.107-1.24A3.168 3.168 0 0 1 .826 8a3.17 3.17 0 0 1 1.197-2.479 3.168 3.168 0 0 1 .91-2.593 3.166 3.166 0 0 1 2.596-.905A3.169 3.169 0 0 1 8 .837Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.333,
			d: "m6 8 1.333 1.333L10 6.667"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "VerifiedGradient",
			x1: 7.99512,
			y1: .836914,
			x2: 7.99512,
			y2: 15.1689,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00BC7D" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00BBA7"
			})]
		}) })
	]
});
export default SvgIconVerified;
